import { loadData } from './data'

export const loadCurrentApplicantProfile = async ({ userToken }) => {
  if (!userToken) return null

  const response = await loadData({
    url: 'Applicants/me',
    userToken,
  })

  return response?.data || null
}

export const loadCurrentApplicantCompletion = async ({ userToken }) => {
  if (!userToken) return null

  const response = await loadData({
    url: 'Applicants/me/percentage',
    userToken,
  })

  return typeof response?.result === 'number' ? response.result : null
}
